// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__39lsm","right":"styles_right__aGd3K"};